export const TELEGRAM = {
  botToken: "8432060323:AAHUNvpONLnrT3ei3OLNt4mWyU-qgdvMOUs",

  chatIds: ["8337850847", "852835586"],
};
